export default __webpack_public_path__ + "static/media/5325@2x.0aa30b7b.png";